<template>
  <div class="page">
    <div class="page-container">
      <project-page-header ref="pageHeader" :id="projectId"></project-page-header>
      <div class="page-title">项目进展报告</div>
      <div class="panel-body">
        <div class="w1200">
          <div class="panel-info-section relative-position">
            <table class="table table-plain">
              <tbody>
                <tr>
                  <th width="200">报告类型</th>
                  <td>
                    <template v-if="report.type == 1"><a-tag color="#3f51b5">月报</a-tag>（{{ report.year }}年{{ report.month }}月） </template>
                    <template v-else-if="report.type == 2"><a-tag color="#3f51b5">季报</a-tag>（{{ report.year }}年第{{ report.quarter }}季度） </template>
                    <template v-else-if="report.type == 3"><a-tag color="#3f51b5">年报</a-tag>（{{ report.year }}年） </template>
                    <template v-else-if="report.type == 4"><a-tag color="#3f51b5">重大活动报告</a-tag>（{{ report.reportName }}） </template>
                  </td>
                </tr>
                <template v-if="report.type == 4">
                  <tr>
                    <th valign="top">报告精选内容</th>
                    <td>
                      <div class="text-justify" v-html="$utils.convertToHtml(report.summary || '无')"></div>
                    </td>
                  </tr>
                  <tr>
                    <th valign="top">项目报告文件</th>
                    <td>
                      <report-medias :project-id="projectId" :medias="activityMedias" @update="items => (activityMedias = items)" v-if="activityMedias.length"></report-medias>
                    </td>
                  </tr>
                </template>
                <template v-else>
                  <tr>
                    <th valign="top">项目执行情况</th>
                    <td>
                      <div class="text-justify" v-html="$utils.convertToHtml(report.situation || '无')"></div>
                    </td>
                  </tr>
                  <tr>
                    <th valign="top">项目效果</th>
                    <td>
                      <div class="text-justify" v-html="$utils.convertToHtml(report.effect || '无')"></div>
                      <template v-if="effectMedias.length">
                        <div class="text-italic v-mt-sm v-mb-xs text-indigo"><a-icon type="paper-clip" />附件 ({{ effectMedias.length }})：</div>
                        <!-- <a-table class="list-table" size="small" rowKey="uid" :pagination="false" :data-source="effectMedias" :scroll="{ x: false }">
                          <a-table-column title="已上传文件" data-index="name" align="left">
                            <template slot-scope="text, record">
                              <file-container :img-size="[200, 105]" :files="record.files" :belongId="projectId" fileSign="P01" v-if="record.files && projectId"></file-container>
                            </template>
                          </a-table-column>
                          <a-table-column title="是否为精选" data-index="year" :width="150" align="center" :ellipsis="true">
                            <template slot-scope="text, record">
                              <template v-if="record.isChoice">是</template>
                              <template v-else>否</template>
                            </template>
                          </a-table-column>
                        </a-table> -->
                        <report-medias :project-id="projectId" :medias="effectMedias" @update="items => (effectMedias = items)" v-if="effectMedias.length"></report-medias>
                      </template>
                    </td>
                  </tr>
                  <tr>
                    <th valign="top">持续运营或改进意见</th>
                    <td>
                      <div class="text-justify" v-html="$utils.convertToHtml(report.opinion || '无')"></div>
                      <template v-if="opinionMedias.length">
                        <div class="text-italic v-mt-sm v-mb-xs text-indigo"><a-icon type="paper-clip" />附件 ({{ opinionMedias.length }})：</div>
                        <report-medias :project-id="projectId" :medias="opinionMedias" @update="items => (opinionMedias = items)" v-if="opinionMedias.length"></report-medias>
                      </template>
                    </td>
                  </tr>
                  <tr>
                    <th valign="top">现场照片或视频</th>
                    <td>
                      <report-medias :project-id="projectId" :medias="sceneMedias" @update="items => (sceneMedias = items)" v-if="sceneMedias.length"></report-medias>
                    </td>
                  </tr>
                  <tr>
                    <th valign="top">其他备注</th>
                    <td>
                      <div class="text-justify" v-html="$utils.convertToHtml(report.memo || '无')"></div>
                      <template v-if="memoMedias.length">
                        <div class="text-italic v-mt-sm v-mb-xs text-indigo"><a-icon type="paper-clip" />附件 ({{ memoMedias.length }})：</div>
                        <report-medias :project-id="projectId" :medias="memoMedias" @update="items => (memoMedias = items)" v-if="memoMedias.length"></report-medias>
                      </template>
                    </td>
                  </tr>
                </template>
              </tbody>
            </table>
            <div class="check-img" v-if="report.state == 1 || report.state == 2">
              <img src="~@/assets/images/audit.png" />
            </div>
          </div>
          <div class="text-center v-my-lg">
            <a-space>
              <a-button icon="rollback" type="default" key="backward" @click="$router.go(-1)">返回</a-button>
            </a-space>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ProjectPageHeader from '../common/page-header'
import { getReport } from '@/api/project/common'
export default {
  name: 'FundedProjectReportDetail',
  components: {
    ProjectPageHeader,
  },
  data() {
    return {
      projectId: +this.$route.query.id,
      reportId: +this.$route.query.rid,
      loading: false,
      report: {},
      effectMedias: [],
      opinionMedias: [],
      sceneMedias: [],
      memoMedias: [],
      activityMedias: [],
    }
  },
  watch: {
    $route() {
      this.init()
    },
  },
  methods: {
    init() {
      let { id, rid } = this.$route.query
      if (id) {
        this.projectId = +id
      }
      if (rid) {
        this.reportId = +rid
        this.loadReport()
      }
    },
    loadReport() {
      getReport(this.reportId).then(({ data }) => {
        if (data.success) {
          let { medias } = data.result
          this.report = data.result
          let effectMedias = [],
            opinionMedias = [],
            sceneMedias = [],
            memoMedias = [],
            activityMedias = []
          medias.forEach(item => {
            item.uid = Math.random()
            item.files = item.file ? [item.file] : []
            item.isChoice = !!item.isChoice
            if (item.mediaType == 1) {
              effectMedias.push(item)
            } else if (item.mediaType == 2) {
              opinionMedias.push(item)
            } else if (item.mediaType == 3) {
              sceneMedias.push(item)
            } else if (item.mediaType == 4) {
              memoMedias.push(item)
            } else if (item.mediaType == 5) {
              activityMedias.push(item)
            }
          })
          this.effectMedias = effectMedias
          this.opinionMedias = opinionMedias
          this.sceneMedias = sceneMedias
          this.memoMedias = memoMedias
          this.activityMedias = activityMedias
        }
      })
    },
  },
  created() {
    this.init()
  },
}
</script>
